module.exports = __webpack_public_path__ + "static/media/belcolor__14.0442c989.jpg";